import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type PodiumSlot = {
  position: number;
  member_id: string;
  first_name: string;
  photo: string;
  leads: number;
  amount: number;
  has_used_redemption?: boolean;
  redemption_passed_at?: string;
};

export type RankingWeek = {
  week_start: string;
  week_end: string;
  podium: PodiumSlot[];
};

export type GroupWeek = {
  week_start: string;
  week_end: string;
  week_total: number;
  week_goal: number;
  your_amount: number;
};

export type RaceCycleType = 'daily' | 'weekly' | 'monthly';

export type RaceClaim = {
  id: string;
  cycle_type: RaceCycleType;
  cycle_start: string;
  cycle_end: string;
  winner: {
    id: string;
    first_name: string;
    photo?: string;
    has_used_redemption?: boolean;
    redemption_passed_at?: string;
  } | null;
  amount_eur: number;
  threshold: number;
  paid_in_payment: string;
};

export function useRankingHistory(enabled: boolean) {
  return useQuery({
    queryKey: ['bonus-history', 'ranking'],
    queryFn: (): Promise<{ weeks: RankingWeek[] }> =>
      pb.send('/api/bonus/ranking-history', { method: 'GET' }),
    enabled,
    staleTime: 60_000,
  });
}

export function useGroupHistory(enabled: boolean) {
  return useQuery({
    queryKey: ['bonus-history', 'group'],
    queryFn: (): Promise<{ weeks: GroupWeek[] }> =>
      pb.send('/api/bonus/group-history', { method: 'GET' }),
    enabled,
    staleTime: 60_000,
  });
}

export function useRaceHistory(enabled: boolean) {
  return useQuery({
    queryKey: ['bonus-history', 'race'],
    queryFn: (): Promise<{ items: RaceClaim[] }> =>
      pb.send('/api/race-bonus/history?perPage=10', { method: 'GET' }),
    enabled,
    staleTime: 60_000,
  });
}
